import { render, staticRenderFns } from "./baijia.vue?vue&type=template&id=0a473b90&scoped=true"
import script from "./baijia.vue?vue&type=script&lang=js"
export * from "./baijia.vue?vue&type=script&lang=js"
import style0 from "./baijia.vue?vue&type=style&index=0&id=0a473b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a473b90",
  null
  
)

export default component.exports